import { render, staticRenderFns } from "./DialogDelivery.vue?vue&type=template&id=3d20b87e&scoped=true"
import script from "./DialogDelivery.vue?vue&type=script&lang=js"
export * from "./DialogDelivery.vue?vue&type=script&lang=js"
import style0 from "./DialogDelivery.vue?vue&type=style&index=0&id=3d20b87e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20b87e",
  null
  
)

export default component.exports